// LinkInternetAccountPage.jsx
import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { UserContext } from "../UserContext";
import { toast } from "react-toastify";
import apiClient from "../../api/client";
import InternetCustomerForm from "../InternetCustomerForm";
import Header from "../Header";

// This one route/page serves both providers — which one is decided by
// a `?type=dvpl` query param (defaults to "internet" when absent, so
// every existing "Link Internet Account" link keeps working unchanged).
// Whoever routes here for DVPL (Customer/index.js's handleLinkDvplAccount)
// just adds that query param instead of needing a whole separate page.
const LinkInternetAccountPage = () => {
  const { id } = useParams();
  const { token } = useContext(UserContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [customer, setCustomer] = useState(null);

  const type = searchParams.get("type") === "dvpl" ? "dvpl" : "internet";
  const providerLabel = type === "dvpl" ? "DVPL" : "Internet";
  const deepLinkParam = type === "dvpl" ? "dvpl" : "internet";

  useEffect(() => {
    const fetchCustomer = async () => {
      const { data } = await apiClient.get(
        `/customer/get_customer_full_details.php?id=${id}`
      );
      setCustomer(data.customer);
    };
    fetchCustomer();
  }, [id]);

  if (!customer) return <p>Loading...</p>;

  return (
    <><Header />
    <div className="form-container">
      <h2>Link {providerLabel} Account — {customer.name} {customer.lastName}</h2>
      <InternetCustomerForm
        mode="link"
        type={type}
        existingUser={customer}
        operatorId={customer.operatorId}
        token={token}
        onSuccess={(data) =>
          navigate(
            `/customer/${id}${data?.internet_account_id ? `?${deepLinkParam}=${data.internet_account_id}` : ""}`,
            { replace: true }
          )
        }
        onCancel={() => navigate(`/customer/${id}`)}
      />
    </div>
    </>
  );
};

export default LinkInternetAccountPage;